import React, { useContext } from 'react';
import {
  ListItem,
  Typography,
  Avatar,
  makeStyles,
  fade,
} from '@material-ui/core';

import moment from 'moment';
// import { db } from '../utils/firebase';

import { UsersContext } from '../context/UsersContext';
// import { MessagesContext } from '../context/MessagesContext';
// import { AuthContext } from '../context/AuthContext';
// import { RoomContext } from '../context/RoomContext';

import randomColor from '../utils/randomColor';
import { useState } from 'react';

const useStyles = makeStyles({
  user: {
    display: 'flex',
  },
  content: {
    flex: 1,
    margin: '0 10px',
  },
  avatar: {
    color: '#fff',
  },
  active: {
    backgroundColor: fade('#555', 0.25),
    '&:hover': {
      backgroundColor: fade('#555', 0.25),
    },
  },
});

export default function User({ username, uid, joined }) {
  // const [ownMessages, setOwnMessages] = useState([]);
  const [color] = useState(randomColor());

  // const { currentUser } = useContext(AuthContext);
  // const setMessages = useContext(MessagesContext)[1];

  const { selectedUser: _selectedUser } = useContext(UsersContext);
  const [selectedUser, setSelectedUser] = _selectedUser;

  // const room =
  //   currentUser.uid > uid
  //     ? `${currentUser.uid}-${uid}`
  //     : `${uid}-${currentUser.uid}`;

  // const roomRef = db.collection('rooms').doc(room);

  // const _unreadMessages = ownMessages.filter(
  //   (message) => message.senderId === uid && message.unread === true
  // ).length;

  // const unreadMessages = selectedUser.uid === uid ? 0 : _unreadMessages;

  // const checkMessagesAsRead = () => {
  //   roomRef
  //     .collection('messages')
  //     .where('senderId', '==', uid)
  //     .get()
  //     .then((snapShot) => {
  //       snapShot.docs.forEach((doc) => {
  //         roomRef.collection('messages').doc(doc.id).update({ unread: false });
  //       });
  //     });
  // };

  // useEffect(() => {
  //   if (currentUser) {
  //     roomRef
  //       .collection('messages')
  //       .orderBy('timestamp', 'asc')
  //       .onSnapshot((snapshot) => {
  //         const _messages = snapshot.docs.map((doc) => ({
  //           ...doc.data(),
  //           id: doc.id,
  //         }));

  //         setOwnMessages(_messages);
  //       });
  //   }
  // }, [currentUser, uid, setMessages, roomRef]);

  // useEffect(() => {
  //   if (selectedUser.uid === uid) {
  //     _unreadMessages && checkMessagesAsRead();
  //   }
  // }, [selectedUser, uid, _unreadMessages]);

  // useEffect(() => {
  //   setColor(_color);
  // }, []);

  const handleClick = () => {
    if (selectedUser.uid !== uid) {
      setSelectedUser({ username, uid, color });
      // _unreadMessages && checkMessagesAsRead();
    }
  };

  const classes = useStyles();

  return (
    <ListItem
      className={`${classes.user} ${
        selectedUser.uid === uid && classes.active
      }`}
      button
      divider
      onClick={handleClick}
    >
      <div>
        <Avatar className={classes.avatar} style={{ backgroundColor: color }}>
          {username[0].toUpperCase()}
        </Avatar>
      </div>
      <div className={classes.content}>
        <Typography variant='body1'>{username}</Typography>
        <Typography variant='body2' color='textSecondary'>
          Joined {moment.utc(joined).local().fromNow()}
        </Typography>
      </div>
      {/* <Fade in={unreadMessages ? true : false}>
        <Badge badgeContent={unreadMessages} color='secondary' />
      </Fade> */}
    </ListItem>
  );
}
